import { FC } from 'react';
import AccordionExpand from 'images/accordion-expand-icon.svg';

const AccordionExpandIcon: FC = () => {
  return <img src={AccordionExpand} alt="arrow-down-icon" />;
};
export default AccordionExpandIcon;
